import {Typography} from "@mui/material";
import React from "react";
import {imperialWeight} from "./imperialWeight";

const getWeights = (params) => {

    if (params.value > 0) {

        return (
            <div>
                <Typography variant={"body2"}
                            sx={{
                                fontSize: "100%"
                            }}>{params.value} kg</Typography>
                <Typography variant={"body2"}
                            sx={{
                                fontSize: "100%"
                            }}>{imperialWeight(params.value)} lbs</Typography>
            </div>
        );
    }
    else
        return ""
}

export default getWeights;